/**
 * /gracias — alias legacy del éxito de checkout.
 *
 * Stripe / MercadoPago a veces seguimos viendo redirects acá (links viejos,
 * config legacy). Reenviamos a la ruta canónica del flujo membresía:
 * `MEMBERSHIP_ROUTE.COMPLETAR_REGISTRO` (`/portal/completar-perfil`) preservando
 * los query params (session_id, plan, source, etc.) para que el post-pago
 * arranque el formulario Clerk con el contexto correcto.
 */

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MEMBERSHIP_ROUTE } from "@/lib/membershipAccessFlow";

const Gracias = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const incoming = new URLSearchParams(window.location.search);
    // Defaults para que /portal/completar-perfil sepa el plan/source aunque el
    // origen legacy no los haya pasado.
    if (!incoming.get("plan")) incoming.set("plan", "exclusiva");
    if (!incoming.get("source")) incoming.set("source", "gracias_legacy");
    const qs = incoming.toString();
    const target = qs
      ? `${MEMBERSHIP_ROUTE.COMPLETAR_REGISTRO}?${qs}`
      : MEMBERSHIP_ROUTE.COMPLETAR_REGISTRO;
    window.location.replace(target);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500 mx-auto mb-4"></div>
        <p className="text-gray-400">{t("graciasRedirect.redirecting")}</p>
      </div>
    </div>
  );
};

export default Gracias;
